import gql from 'graphql-tag';

export const SEARCH_WORKS = gql`
  query searchWorks($idValue: String!) {
    SearchWorks(title:$idValue) {
      id,
      title
    }
  }
`;

export const GET_WORK = gql`
  query Work (
    $id: ID,
    $iswc: String,
    $proprietaryId: String,
    $proprietaryIDNamespace: String,
    $opusNumber: String,
    $composerCatalogNumber: String,
    $title: String,
    $titleType: String,
    $subTitle: String,
    $subTitleType: String,
    $alternateTitle: String,
    $alternateTitleType: String,
    $alternateSubTitle: String,
    $alternateSubTitleType: String,
    $creationDate: _Neo4jDateTimeInput,
    $lyrics: String,
    $musicalWorkType: String,
    $isMedley: Boolean,
    $isRemix: Boolean
  ) {
  Work(
    id: $id,
    iswc: $iswc,
    proprietaryId: $proprietaryId,
    proprietaryIDNamespace: $proprietaryIDNamespace,
    opusNumber: $opusNumber,
    composerCatalogNumber: $composerCatalogNumber,
    title: $title,
    titleType: $titleType,
    subTitle: $subTitle,
    subTitleType: $subTitleType,
    alternateTitle: $alternateTitle,
    alternateTitleType: $alternateTitleType,
    alternateSubTitle: $alternateSubTitle,
    alternateSubTitleType: $alternateSubTitleType,
    creationDate: $creationDate,
    lyrics: $lyrics,
    musicalWorkType: $musicalWorkType,
    isMedley: $isMedley,
    isRemix: $isRemix
  ) {
    id,
    iswc,
    proprietaryId,
    proprietaryIDNamespace,
    opusNumber,
    composerCatalogNumber,
    title,
    titleType,
    subTitle,
    subTitleType,
    alternateTitle,
    alternateTitleType,
    alternateSubTitle,
    alternateSubTitleType,
    creationDate { formatted },
    lyrics,
    musicalWorkType,
    isMedley,
    isRemix,
    contributions {
      contributor {
        id,
        fullName,
        __typename
      }
      role,
      isCredited,
      creditText,
      featured
    }
    rightShares {
      id,
      percent,
      territoryCode,
      owners {
        id,
        fullName,
        __typename
      }
      controllers {
        id,
        fullName,
        __typename
      }
      administrators {
        id,
        fullName,
        __typename
      }
      for {
        id,
        role
      }

    }
    publisher {
      id,
      fullName,
      __typename
    }
    instancesOf {
      id,
      title,
      __typename
    }
  }
}
`;

export const CREATE_WORK = gql`
  mutation createWork (
    $id: ID,
    $iswc: String,
    $proprietaryId: String,
    $proprietaryIDNamespace: String,
    $opusNumber: String,
    $composerCatalogNumber: String,
    $title: String,
    $titleType: String,
    $subTitle: String,
    $subTitleType: String,
    $alternateTitle: String,
    $alternateTitleType: String,
    $alternateSubTitle: String,
    $alternateSubTitleType: String,
    $creationDate: _Neo4jDateTimeInput,
    $lyrics: String,
    $musicalWorkType: String,
    $isMedley: Boolean,
    $isRemix: Boolean
  ) {
  CreateWork(
    id: $id,
    iswc: $iswc,
    proprietaryId: $proprietaryId,
    proprietaryIDNamespace: $proprietaryIDNamespace,
    opusNumber: $opusNumber,
    composerCatalogNumber: $composerCatalogNumber,
    title: $title,
    titleType: $titleType,
    subTitle: $subTitle,
    subTitleType: $subTitleType,
    alternateTitle: $alternateTitle,
    alternateTitleType: $alternateTitleType,
    alternateSubTitle: $alternateSubTitle,
    alternateSubTitleType: $alternateSubTitleType,
    creationDate: $creationDate,
    lyrics: $lyrics,
    musicalWorkType: $musicalWorkType,
    isMedley: $isMedley,
    isRemix: $isRemix
  ) {
    id,
    iswc,
    proprietaryId,
    proprietaryIDNamespace,
    opusNumber,
    composerCatalogNumber,
    title,
    titleType,
    subTitle,
    subTitleType,
    alternateTitle,
    alternateTitleType,
    alternateSubTitle,
    alternateSubTitleType,
    creationDate { formatted },
    lyrics,
    musicalWorkType,
    isMedley,
    isRemix
  }
}
`;

export const UPDATE_WORK = gql`
  mutation updateWork (
    $id: ID!,
    $iswc: String,
    $proprietaryId: String,
    $proprietaryIDNamespace: String,
    $opusNumber: String,
    $composerCatalogNumber: String,
    $title: String,
    $titleType: String,
    $subTitle: String,
    $subTitleType: String,
    $alternateTitle: String,
    $alternateTitleType: String,
    $alternateSubTitle: String,
    $alternateSubTitleType: String,
    $creationDate: _Neo4jDateTimeInput,
    $lyrics: String,
    $musicalWorkType: String,
    $isMedley: Boolean,
    $isRemix: Boolean
  ) {
  UpdateWork(
    id: $id,
    iswc: $iswc,
    proprietaryId: $proprietaryId,
    proprietaryIDNamespace: $proprietaryIDNamespace,
    opusNumber: $opusNumber,
    composerCatalogNumber: $composerCatalogNumber,
    title: $title,
    titleType: $titleType,
    subTitle: $subTitle,
    subTitleType: $subTitleType,
    alternateTitle: $alternateTitle,
    alternateTitleType: $alternateTitleType,
    alternateSubTitle: $alternateSubTitle,
    alternateSubTitleType: $alternateSubTitleType,
    creationDate: $creationDate,
    lyrics: $lyrics,
    musicalWorkType: $musicalWorkType,
    isMedley: $isMedley,
    isRemix: $isRemix
  ) {
    id,
    iswc,
    proprietaryId,
    proprietaryIDNamespace,
    opusNumber,
    composerCatalogNumber,
    title,
    titleType,
    subTitle,
    subTitleType,
    alternateTitle,
    alternateTitleType,
    alternateSubTitle,
    alternateSubTitleType,
    creationDate { formatted },
    lyrics,
    musicalWorkType,
    isMedley,
    isRemix
  }
}
`;

export const DELETE_WORK = gql`
  mutation deleteWork (
    $id: ID!
  ) {
  DeleteWork(
    id: $id
  ) {
    id
  }
}
`;


// AddWorkContributions(
//   from: _ContributionInput!
//   to: _WorkInput!
// ): _AddWorkContributionsPayload
// RemoveWorkContributions(
//   from: _ContributionInput!
//   to: _WorkInput!
// ): _RemoveWorkContributionsPayload
// AddWorkRightShares(
//   from: _ShareInput!
//   to: _WorkInput!
// ): _AddWorkRightSharesPayload
// RemoveWorkRightShares(
//   from: _ShareInput!
//   to: _WorkInput!
// ): _RemoveWorkRightSharesPayload
